export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyDEmoEwUUg6pJrEMQhkHpfn3gTv3zV6Lpg",
        authDomain: "schule-daegerlen.firebaseapp.com",
        databaseURL: "https://schule-daegerlen.firebaseio.com",
        projectId: "schule-daegerlen",
        storageBucket: "schule-daegerlen.appspot.com",
        messagingSenderId: "353706142376",
        appId: "1:353706142376:web:0020e3cb2c333c2b5f309d"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts